import { FC, CSSProperties, useMemo } from "react";
import styled from "styled-components";
import { useMediaQuery } from "helpers/hooks";
import { banners, BannerItem } from "helpers/banners";

interface BannerProps {
  style?: CSSProperties;
  isSmall?: boolean;
  companyId?: number;
}

const Banner: FC<BannerProps> = ({ style, isSmall, companyId }) => {
  const companyBannerData = useMemo<BannerItem | undefined>(() => {
    if (companyId) {
      return Object.entries(banners).find(
        (el) => Number(el[0]) === companyId
      )?.[1];
    }
  }, [companyId]);

  const desktop = useMediaQuery("(min-width: 36em)");

  return (
    <>
      {companyBannerData && (
        <StyledBannerContainer
          $background={
            desktop
              ? isSmall
                ? companyBannerData.mediumBg
                : companyBannerData.mainBg
              : companyBannerData.smallBg
          }
          $isSmall={isSmall}
          style={style}
        >
          <StyledBanner>
            <img
              src={
                desktop
                  ? isSmall
                    ? companyBannerData.medium
                    : companyBannerData.main
                  : companyBannerData.small
              }
              alt="banner"
            />
          </StyledBanner>
        </StyledBannerContainer>
      )}
    </>
  );
};

interface StyledBannerInterface {
  $isSmall?: boolean;
  $background: string;
}
const StyledBannerContainer = styled.div<StyledBannerInterface>`
  margin: 0;
  background: ${({ $background }) => $background};
  // background: linear-gradient(
  //   90deg,
  //   rgba(11, 30, 44, 1) 50%,
  //   rgba(20, 43, 55, 1) 50%
  // );
  width: 100%;
  padding: 0 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $isSmall }) =>
    !$isSmall &&
    `    @media (min-width: 36em) {
    margin: 1rem 0;
  }
    @media (min-width: 48em) {
    margin: 2rem 0;
  }`}
`;

const StyledBanner = styled.div`
  margin: 0;
  max-width: 35rem;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    max-height: 9.6rem;
  }

  @media (min-width: 36em) {
    max-width: 64rem;
  }
`;

export default Banner;
